import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-deletion-instructions-url',
  templateUrl: './data-deletion-instructions-url.component.html',
  styleUrls: ['./data-deletion-instructions-url.component.scss']
})
export class DataDeletionInstructionsUrlComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
